import { VhcRecordLogService } from 'api/generated';
import { QueryError } from 'features/shared/model';
import { useQuery, UseQueryOptions } from 'react-query';

export type GetVhcRecordPartsInput = {
  id: number;
};

export const usePartsQueryKey = 'PartsQueryKey';

export const fetchVhcRecordParts = async (vhcRecord: number) => {
  const data = await VhcRecordLogService.getVhcRecordsParts(vhcRecord);
  const { checkBrakeItemParts, checkItemParts, checkWheelTyreItemParts } = data || {};

  const items = [...(checkBrakeItemParts ?? []), ...(checkItemParts ?? []), ...(checkWheelTyreItemParts ?? [])];

  return {
    items: items.length > 0 ? items : null
  };
};

export const useGetVhcRecordPartsQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  id: number,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchVhcRecordParts>>,
      QueryError,
      Awaited<ReturnType<typeof fetchVhcRecordParts>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([usePartsQueryKey, ...(queryKey ?? [id])], () => fetchVhcRecordParts(id), options);
